module.exports = __webpack_public_path__ + "img/48.a114b9fe.svg";